///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-base.ts"/>
///<reference path="../collections/report-merchant-account.collection.ts"/>

module Meevo.Components.Controls.SmartMover {
    import Dictionary = _.Dictionary;

    export class ReportMerchantAccountsDataTemplate extends DataTemplateBase  implements IDataTemplate {

        protected merchantAccounts: ReportMerchantAccountCollection;

        public allSelectedLabel: string;
        public title: string;

        get collection() {
            return this.merchantAccounts;
        }


        constructor(model: Dictionary<any>, properties: string[], { criteria }) {
            super(model, properties, criteria);
            this.merchantAccounts = new ReportMerchantAccountCollection(model[properties[0]], [], {
                criteria
            }
            );

            this.allSelectedLabel = 'LABEL_ALL_MERCHANT_ACCOUNTS';
        }
    }
}